import React from "react";
import { LinearProgress } from "@mui/material";
import { Box } from "@mui/system";

import { StyledProgressBar } from "./styled";
import { ICONS, Icon } from "../Icons";

const statusIcons = {
  inActive: ICONS.inActive,
  active: ICONS.active,
  completed: ICONS.completed
};

export const ProgressBar = ({
  label = "Your info",
  value = 0,
  status = "inActive",
  isMobile = false
}) => {
  const extraClass =
    status === "completed" ? "completed" : status === "inActive" ? "inActive" : "active";
  const isMobileClass = isMobile ? "mobileProgressBar" : "";
  return (
    <StyledProgressBar isMobile={isMobile}>
      <Box className={`progressBarStep ${extraClass} ${isMobileClass}`}>
        {!isMobile && (
          <div className="progressBarStepHeader" data-testid="progressBarStepHeader">
            <Icon
              className={`progressBarIcon ${status}`}
              name={statusIcons[status]}
              alt="selected icon"
            />
            <span className="progressBarLabel">{label}</span>
          </div>
        )}
        <div className="progressBarSubsteps">
          <LinearProgress variant="determinate" value={value} />
        </div>
      </Box>
    </StyledProgressBar>
  );
};
